import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import ChannelList from './ChannelList'
// import MemberList from './MemberList'
import MobileNav from './MobileNav'
import MobileHeader from './MobileHeader'
import useOrg from '../../hooks/useOrg'

export default function AppLayout() {
  const org = useOrg()
  const [drawerOpen, setDrawerOpen] = useState(false)
  // const [membersOpen, setMembersOpen] = useState(false)

  return (
    <div
      className="flex h-dvh overflow-hidden"
      style={{
        '--color-primary': org.colorPrimary,
        '--color-primary-hover': org.colorPrimaryHover,
        '--color-primary-light': `${org.colorPrimary}20`,
      } as React.CSSProperties}
    >
      {/* Mobile Drawer Overlay */}
      {drawerOpen && (
        <div
          className="fixed inset-0 bg-black/60 z-40 lg:hidden animate-fade-in"
          onClick={() => setDrawerOpen(false)}
        />
      )}

      {/* Mobile Members Overlay — desabilitado por enquanto */}
      {/* {membersOpen && (
        <div
          className="fixed inset-0 bg-black/60 z-40 lg:hidden animate-fade-in"
          onClick={() => setMembersOpen(false)}
        />
      )} */}

      {/* Mobile Channel Drawer */}
      <div
        className={`fixed inset-y-0 left-0 z-50 flex transition-transform duration-300 ease-in-out lg:hidden ${
          drawerOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <Sidebar onNavigate={() => setDrawerOpen(false)} />
        <ChannelList onChannelClick={() => setDrawerOpen(false)} />
      </div>

      {/* Mobile Members Drawer — desabilitado por enquanto */}
      {/* <div
        className={`fixed inset-y-0 right-0 z-50 transition-transform duration-300 ease-in-out lg:hidden ${
          membersOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <MemberList forceShow />
      </div> */}

      {/* Desktop Sidebar */}
      <div className="hidden lg:block">
        <Sidebar />
      </div>

      {/* Desktop Channel List */}
      <div className="hidden lg:block">
        <ChannelList />
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0 pb-14 lg:pb-0 bg-surface-primary">
        {/* Mobile Header */}
        <MobileHeader
          onMenuClick={() => setDrawerOpen(true)}
          // onMembersClick={() => setMembersOpen(true)}
        />

        <Outlet />
      </div>

      {/* Desktop Member List — desabilitado por enquanto */}
      {/* <div className="hidden lg:block">
        <MemberList />
      </div> */}

      {/* Mobile Bottom Nav */}
      <MobileNav onMenuClick={() => setDrawerOpen(true)} />
    </div>
  )
}
